document.addEventListener('alpine:init', () => {
  Alpine.data("headerMenu", () => ({
    submenuOpen: false,
  }));

  Alpine.data("headerMenuItem", () => ({
    open: false,
    headerMenuItemChild: {
      ['x-init']() {
        this.$watch("open", (open) => {
          Alpine.store("submenuOpen", open);
          if (open) {
            window.slideDown(this.$el);
          }
          else {
            window.slideUp(this.$el);
          }
        });
      }
    },
  }));

  //Summenu hover card controller
  Alpine.data("headerSubMenu", () => ({
    neverHovered: true,
    lastItemHovered: false,
    headerSubMenuItemLink: {
      ["@focus"](e) {
        const closestListElement = e.target.parentNode;
        if (closestListElement.querySelectorAll(".menu-card").length) {
          this.lastItemHovered = closestListElement;
          this.neverHovered = false;

          // closestListElement.querySelectorAll(".menu-card");
        }
      }
    },
    headerSubMenuItem: {
      ["@mouseenter"](e) {
        const closestListElement = e.target;
        if (closestListElement.querySelectorAll(".menu-card").length) {
          this.lastItemHovered = closestListElement;
          this.neverHovered = false;
        }
      },
      [":class"]() {
        const isFirstSubmenuItem =
          Array.prototype.indexOf.call(
            this.$el.parentNode.children,
            this.$el
          ) == 0;

        const isLastItemHovered = this.$el == this.lastItemHovered;

        //If unhovered or last hovered, show children
        return (isFirstSubmenuItem && this.neverHovered) || isLastItemHovered
          ? "js-last-hovered"
          : "";
      },
    },
    menuCardGroup: {
    },
  }));
});
